import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {
  headerLogoSlice,
  headerLogoAltTextSlice,
  headerLogoHeadingSlice,
  isBrandingAppliedSlice,
  footerLeftMarkdownSlice,
  footerRightMarkdownSlice,
  faviconSlice,
} from './reducers/brandingReducers';
import {useDispatch, useSelector} from 'react-redux';

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

// Use throughout app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

const rootReducer = combineReducers({
  isBrandingApplied: isBrandingAppliedSlice.reducer,
  headerLogo: headerLogoSlice.reducer,
  headerLogoAltText: headerLogoAltTextSlice.reducer,
  headerLogoText: headerLogoHeadingSlice.reducer,
  footerLeftMarkdown: footerLeftMarkdownSlice.reducer,
  footerRightMarkdown: footerRightMarkdownSlice.reducer,
  favicon: faviconSlice.reducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
}

export const store = setupStore();
